<script lang="ts" setup></script>

<template>
	<div
		class="sticky bottom-0 z-[101] bg-white pb-[calc(12px+env(safe-area-inset-bottom))] pl-[env(safe-area-inset-left)] pr-[env(safe-area-inset-right)] pt-[calc(12px+env(safe-area-inset-top))] shadow-[0px_0px_32px_32px_white] lgOld:shadow-none"
	>
		<slot />
	</div>
</template>
